import { Router } from '@angular/router'
import { ActionReducer } from '@ngrx/store'
import { AuthService } from './containers/auth/auth.service'

export function refreshToken(auth: AuthService, router: Router) {
  return (reducer: ActionReducer<any>): ActionReducer<any> =>
    (state, action) => {
      if (auth.getToken() && state) {
        const currentTime = Date.now()
        const tokenExpDate = auth.tokenExpDate()
        const refreshThreshold = Math.floor((currentTime + 300000) / 1000)
        if (
          refreshThreshold >= tokenExpDate ||
          Math.floor(currentTime / 1000) >= tokenExpDate
        ) {
          const isLoading = auth.isTokenRefreshing.value
          if (!isLoading) {
            auth.isTokenRefreshing.next(true)
            auth.refreshToken().subscribe(
              (response) => {
                auth.isTokenRefreshing.next(false)
                auth.setUser(response.data)
              },
              () => {
                // router.navigate(['/auth/login'])
              },
            )
          }
        }
      }
      return reducer(state, action)
    }
}

export const metaReducers: any[] = [refreshToken]
